import { render, staticRenderFns } from "./AboutUsView.vue?vue&type=template&id=92f6e934&scoped=true&"
import script from "./AboutUsView.vue?vue&type=script&lang=ts&"
export * from "./AboutUsView.vue?vue&type=script&lang=ts&"
import style0 from "./AboutUsView.vue?vue&type=style&index=0&id=92f6e934&prod&lang=css&"
import style1 from "./AboutUsView.vue?vue&type=style&index=1&id=92f6e934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f6e934",
  null
  
)

export default component.exports